import * as products from 'app/mocks/data/catalogue/products/list'
import * as managers from 'app/mocks/data/park/managers/list'
import * as sites from 'app/mocks/data/park/sites/list'
import * as konvives from 'app/mocks/data/users/konvives/list'

import { newDateFormatted } from 'app/utils/date'

import { Order, StatusOrder } from 'app/types/operations/order'

export const order201: Order = {
    id: 201,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive5,
    site: sites.site2,
    price: 2,
    articles: [
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 3_000,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-20)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive5,
            changes: [
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 3_000,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-20)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: konvives.konvive5,
            changes: [],
        },
    ],
}

export const order202: Order = {
    id: 202,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive5,
    site: sites.site2,
    price: 2,
    articles: [
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 3_000,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-19)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive5,
            changes: [
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 10_000,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-19)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 3_000,
                },
            ],
        },
    ],
}

export const order203: Order = {
    id: 203,
    status: StatusOrder.enum.ON_DELIVERY,
    phone_number: '0607080910',
    site: sites.site12,
    price: 2,
    articles: [
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 300,
        },
        {
            product: products.product6,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-18)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0607080910',
            changes: [
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 300,
                },
                {
                    product: products.product6,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-18)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order204: Order = {
    id: 204,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive2,
    site: sites.site18,
    price: 2,
    articles: [
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-17)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product6,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-17)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
    ],
}
export const order205: Order = {
    id: 205,
    status: StatusOrder.enum.ON_DELIVERY,
    phone_number: '0611121314',
    site: sites.site5,
    price: 2,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: true,
            quantity: 400,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-16)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0611121314',
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: true,
                    quantity: 400,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-16)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [],
        },
    ],
}

export const order206: Order = {
    id: 206,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive3,
    site: sites.site11,
    price: 2,
    articles: [
        {
            product: products.product12,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product13,
            is_weight_quantity: true,
            quantity: 200,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-15)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive3,
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: true,
                    quantity: 400,
                },
                {
                    product: products.product11,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-15)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager5,
            changes: [
                {
                    product: products.product12,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product13,
                    is_weight_quantity: true,
                    quantity: 200,
                },
            ],
        },
    ],
}

export const order207: Order = {
    id: 207,
    status: StatusOrder.enum.ON_DELIVERY,
    phone_number: '0615161718',
    site: sites.site16,
    price: 2,
    articles: [
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-14)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0615161718',
            changes: [
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-14)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager5,
            changes: [],
        },
    ],
}

export const order208: Order = {
    id: 208,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive4,
    site: sites.site21,
    price: 2,
    articles: [
        {
            product: products.product17,
            is_weight_quantity: true,
            quantity: 350,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-13)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive4,
            changes: [
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager2,
            changes: [
                {
                    product: products.product17,
                    is_weight_quantity: true,
                    quantity: 350,
                },
            ],
        },
    ],
}

export const order209: Order = {
    id: 209,
    status: StatusOrder.enum.ON_DELIVERY,
    phone_number: '0619202122',
    site: sites.site4,
    price: 2,
    articles: [
        {
            product: products.product19,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product20,
            is_weight_quantity: true,
            quantity: 275,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-12)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0619202122',
            changes: [
                {
                    product: products.product19,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product20,
                    is_weight_quantity: true,
                    quantity: 275,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order210: Order = {
    id: 210,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive5,
    site: sites.site9,
    price: 2,
    articles: [
        {
            product: products.product22,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-11)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive5,
            changes: [
                {
                    product: products.product19,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product20,
                    is_weight_quantity: true,
                    quantity: 275,
                },
                {
                    product: products.product22,
                    is_weight_quantity: false,
                    quantity: 15,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-11)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [
                {
                    product: products.product22,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
    ],
}

export const order211: Order = {
    id: 211,
    status: StatusOrder.enum.ON_DELIVERY,
    phone_number: '0623242526',
    site: sites.site14,
    price: 2,
    articles: [
        {
            product: products.product24,
            is_weight_quantity: true,
            quantity: 450,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-10)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0623242526',
            changes: [
                {
                    product: products.product24,
                    is_weight_quantity: true,
                    quantity: 450,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-10)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order212: Order = {
    id: 212,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive6,
    site: sites.site19,
    price: 2,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 225,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-9)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive6,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-9)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager7,
            changes: [
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 225,
                },
            ],
        },
    ],
}

export const order213: Order = {
    id: 213,
    status: StatusOrder.enum.ON_DELIVERY,
    phone_number: '0627282930',
    site: sites.site2,
    price: 2,
    articles: [
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 5,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-9)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0627282930',
            changes: [
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 5,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-9)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order214: Order = {
    id: 214,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive7,
    site: sites.site8,
    price: 2,
    articles: [
        {
            product: products.product6,
            is_weight_quantity: true,
            quantity: 325,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-8)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive7,
            changes: [
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 5,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-8)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [
                {
                    product: products.product6,
                    is_weight_quantity: true,
                    quantity: 325,
                },
            ],
        },
    ],
}

export const order215: Order = {
    id: 215,
    status: StatusOrder.enum.ON_DELIVERY,
    phone_number: '0631323334',
    site: sites.site13,
    price: 2,
    articles: [
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product9,
            is_weight_quantity: true,
            quantity: 175,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-7)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0631323334',
            changes: [
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product9,
                    is_weight_quantity: true,
                    quantity: 175,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-7)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order216: Order = {
    id: 216,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive8,
    site: sites.site17,
    price: 2,
    articles: [
        {
            product: products.product11,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-6)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive8,
            changes: [
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product9,
                    is_weight_quantity: true,
                    quantity: 175,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-6)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [
                {
                    product: products.product11,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
    ],
}

export const order217: Order = {
    id: 217,
    status: StatusOrder.enum.ON_DELIVERY,
    phone_number: '0635363738',
    site: sites.site20,
    price: 2,
    articles: [
        {
            product: products.product13,
            is_weight_quantity: true,
            quantity: 375,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-5)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0635363738',
            changes: [
                {
                    product: products.product13,
                    is_weight_quantity: true,
                    quantity: 375,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-5)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order218: Order = {
    id: 218,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive9,
    site: sites.site6,
    price: 2,
    articles: [
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product16,
            is_weight_quantity: true,
            quantity: 150,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-4)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive9,
            changes: [
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-4)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager9,
            changes: [
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product16,
                    is_weight_quantity: true,
                    quantity: 150,
                },
            ],
        },
    ],
}

export const order219: Order = {
    id: 219,
    status: StatusOrder.enum.ON_DELIVERY,
    phone_number: '0639404142',
    site: sites.site10,
    price: 2,
    articles: [
        {
            product: products.product18,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-3)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0639404142',
            changes: [
                {
                    product: products.product18,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-3)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager9,
            changes: [],
        },
    ],
}

export const order220: Order = {
    id: 220,
    status: StatusOrder.enum.ON_DELIVERY,
    konvive: konvives.konvive10,
    site: sites.site15,
    price: 2,
    articles: [
        {
            product: products.product21,
            is_weight_quantity: true,
            quantity: 425,
        },
        {
            product: products.product22,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-2)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive10,
            changes: [
                {
                    product: products.product18,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-2)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager10,
            changes: [
                {
                    product: products.product21,
                    is_weight_quantity: true,
                    quantity: 425,
                },
                {
                    product: products.product22,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
    ],
}
